
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import { ORDER_PAGE_VISITED } from "@/constants/MixpanelEvents.js";
import OnHoldButton from "../common/on-hold-button.vue";
import RefreshButton from "../common/refresh-button.vue";
import cloudKitchen from "./cloud-kitchen.vue";
import RecieverSearchField from "./reciever-search-field.vue";
import ReportsButton from "../common/reports-button.vue";
import LocationOnlineStatusHandler from "./location-online-status-handler.vue";
import RecieverChannelMobile from "./reciever-channel-mobile.vue";
import AppBarMobile from "../common/app-bar-mobile.vue";
import RecieverChannelsRow from "./reciever-channels-row.vue";
import OrderList from "./order-list.vue";
import OrderGrid from "./order-grid.vue";
import AvailableBrandsDialog from "../dialogs/available-brands-dialog.vue";
import AddNewBrandDialog from "../dialogs/add-new-brand-dialog.vue";
import BrandHamburgerMenu from "../common/brand-hamburger-menu.vue";
import { ALL_CHANNELS } from "@/constants/Channels.js";

export default {
  components: {
    cloudKitchen,
    RecieverSearchField,
    RefreshButton,
    ReportsButton,
    LocationOnlineStatusHandler,
    RecieverChannelsRow,
    OrderList,
    RecieverChannelMobile,
    OrderGrid,
    AppBarMobile,
    OnHoldButton,
    AvailableBrandsDialog,
    AddNewBrandDialog,
    BrandHamburgerMenu,
    integrationStepperWizard: () =>
      import("@/components/reciever/integration-stepper-wizard.vue")
  },
  data() {
    return {
      channelsPairedAndEmptyMenubook: false,
      showPairingTooltip: true,
      showAvailableBrands: false,
      showAddBrandDialog: false,
      onlinePlatformNames: []
    };
  },
  computed: {
    ...mapState("restaurant", ["locationDetails", "restaurantChannels"]),
    ...mapState("reciever", ["onHoldOrders", "selectedChannel"]),
    ...mapGetters("restaurant", [
      "hasMultipleBrands",
      "getLocationChannels",
      "activeChannelCount"
    ]),

    enableOnHoldButton() {
      return (
        this.locationDetails.restaurants.some(
          (el) => el.features?.order_modification
        ) && this.onHoldOrders?.length > 0
      );
    },
    hasChannelsPaired() {
      return this.getLocationChannels?.length > 0;
    },
    showIntegrationStepper() {
      if (this.hasMultipleBrands) {
        return false;
      } else {
        if (!this.hasChannelsPaired) {
          return false;
        }
        if (!this.activeChannelCount) {
          return true;
        } else {
          if (this.isChannelIntegrationOngoing(this.selectedChannel)) {
            return true;
          } else {
            return false;
          }
        }
      }
    }
  },

  mounted() {
    this.mixPanelTrackEvent(ORDER_PAGE_VISITED);
    if (this.$route.params && this.$route.params.showWhatsappTab) {
      this.SET_SELECTED_CHANNEL(this.$constants.Channels.WHATSAPP);
    }
  },
  created() {
    this.init();
    this.$nuxt.$on("switch-restaurant", this.init);
  },
  methods: {
    ...mapActions("restaurant", ["getRestaurantChannels"]),
    ...mapActions("reciever", ["getOrders"]),
    ...mapMutations("reciever", ["SET_SELECTED_CHANNEL"]),

    init() {
      this.getRestaurantChannels();
      this.getOrders();
    },
    isChannelIntegrationOngoing(channel) {
      if (channel.name === ALL_CHANNELS.name) {
        return false;
      }

      const selectedChannelObj =
        this.locationDetails.restaurants[0].restaurant_platforms.find(
          (platform) => platform.platform_name === channel.name
        );
      return selectedChannelObj.state === "integration_ongoing";
    },
    handleOpenMenubookTooltip() {
      this.showPairingTooltip = false;
    },
    showBrandsDialog() {
      this.showAvailableBrands = true;
    }
  },
  beforeDestroy() {
    this.$nuxt.$off("switch-restaurant");
  }
};
